// 组队相关
export default {
  CHECK_NAME: '/api/team/checkName',                   // 检查队名合法性
  CREATE_TEAM: '/api/team/create',                     // 创建新的团队
  JOIN_TEAM: '/api/team/joinTeam',                     // 加入团队
  TEAM_DETAIL: '/api/team/detail',                     // 组队详情
  TEAM_QUIT: '/api/team/quit',                         // 退出团队
  TEAM_UPDATE: '/api/team/update',                     // 修改团队信息
  CHANG_TEAMBG: '/api/team/update/teamBg',                     // 更换队伍头像
  SAVE_TEAM_RECRUITDESC: '/api/team/update/teamRecruitDesc', // 保存团队信息
  USER_UPDATE_DECLARE: '/api/team/person/declare/update',      // 修改个人寻队信息
  TEAM_GET_INVITEDETAIL: '/api/team/getInviteDetail',      // 获取组队信息（站内信）
  TEAM_INVITE: '/api/team/invite',                     // 发送邀请
  JOIN_INVITE: '/api/team/joinByInvite',               // 接受邀请
  REJECT_INVITE: '/api/team/rejectInvite',             // 拒绝邀请
  DUSSOLVE_TEAM: '/api/team/dissolveTeam',             // 解散团队
  TEAM_LIST: '/api/team/myTeams',                       // 团队列表
  REMOVE_MEMBERS: '/api/team/removerMembers',          // 移除队员
  CONFIRM_TEAM: '/api/team/confirmTeam',               // 确定组队
  CHANG_LEADER: '/api/team/changLeader',               // 更换队伍队长
  RECOMMEN_USERS: '/api/team/recommendUsers',          // 搜索站内邀请人员
  GTE_TEAMLIST: '/api/team/getTeamList',               // 获取组队推荐列表
  GTE_TEAM_DECLARE: '/api/team/person/declare/list',    // 获取个人寻队列表
  GTE_TEAM_DECLARE_INFO: '/api/team/person/declare',    // 获取个人寻队列表
  TEAM_CONFIG: '/api/team/teamConfig',                 // 获取队伍配置
  GTE_QRCODE: '/api/team/generateShareQRCode',          // 获取二维码
  DYNAMIC_ADD: '/api/dynamic/add',                      // 发布动态
  GROUP_INFO: '/api/contest/group/groupInfo',           // 组队消息
  DYNAMIC_DELETE: '/api/dynamic/delete',                // 删除动态
  TEAM_SCHOOL: '/api/team/teamSchools',                 // 组别学校
  SET_GROUP: '/api/contest/group/setGroup',             // 设置组别
  UPDATE_SCHOOL: '/api/team/updateTeamSchools',         // 修改学校
  DYNAMIC_LIST: '/api/dynamic/list',                     // 动态列表
  BIG_SHOT: '/api/bigShot/list',                        // 大咖列表
  POSTS_LIST: '/api/posts/list',                         // 动态列表
  TOPIC_LIST: '/api/common/webList',                       // 话题列表
  TOPIC_INFO: '/api/common/info',                       // 话题详情
  TOPIC_DELEE: '/api/posts/delete',                       // 删除话题
  ACTIVITE_RECOMMEND: '/api/bigShot/contestRecommend',   // 推荐活动
  COMMENT_ADD: '/api/web/comment/add',                  // 发表评论
  PRAISE_SAVE: '/api/web/praise/save',            // 点赞和取消点赞
  COMMENT_LIST: '/api/web/comment/list',                // 评论列表
  POSTS_READ: '/api/posts/read',                          // 阅读帖子
  POST_PUBLISH: '/api/posts/publish'                     // 发布动态
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/team.js